import './masturbationGame.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import parse from 'html-react-parser'
import background from'../../images/masturbationGameBG.png'
import hand from'../../images/masturbationGameHand.png'
import { dialogEducationFirstEn, dialogEducationEn, dialogEducationSkipEn, lowerSpeedArrEn, secondStageArrEn, thirdStageArrEn, fourthStageArrEn, fifthStageArrEn, sixthStageArrEn, finalStageArrEn, dialogEducationFirstRu, dialogEducationRu, dialogEducationSkipRu, lowerSpeedArrRu, secondStageArrRu, thirdStageArrRu, fourthStageArrRu, fifthStageArrRu, sixthStageArrRu, finalStageArrRu } from'../../services/masturbationGameText'

function MasturbationGame({goMenu, isLS, goNext, state, step, achievementsSave, language, hzAdjuster}) {
  const [saveAchievements, setSaveAchievements] = useState(0);
  //
  const bgRef = useRef(null);
  const handRef = useRef(null);
  const charRefLeft = useRef(null);
  const charRefRight = useRef(null);
  const textBoxLeft = useRef(null);
  const textBoxRight = useRef(null);
  const textBoxCover = useRef(null);
  const answersBox = useRef(null);
  const answerBox0 = useRef(null);
  const answerBox1 = useRef(null);
  const answerBox2 = useRef(null);
  const answerBox3 = useRef(null);
  const wrap = useRef(null);
  const wrapMast = useRef(null);
  const arrowBack = useRef(null);
  const achievement = useRef(null);
  const range = useRef(null);
  let exit = useRef(null);
  let help = useRef(null);
  let particles = useRef(null);
  let helpWith = useRef(null);
  let stamina = useRef(null);
  let parametrs = useRef(null);
  //
  let stopTexting = useRef(false);
  let tryNum = useRef(0);
  let educationProcess = useRef(false);
  let texting = useRef(false);
  let skipButton = useRef(false);
  let prevPosition = useRef();
  let removeChar = useRef(false);
  let removeCharPosition = useRef(false);
  let answered = useRef(false);
  let answering = useRef(false);
  let arrowBackVisible = useRef(false);
  let animationBGPosition = useRef(0);
  let animationHandPosition = useRef(0);
  let backMenuCheck = useRef(false);
  let staminaLeft = useRef(100);
  let prevSpeed = useRef([0,0,0]);
  let prevPos = useRef(undefined);
  let topTime = useRef(undefined);
  let bottomTime = useRef(undefined);
  let speed = useRef("default");
  let speedPrev = useRef(undefined);
  let stopHandAnimation = useRef(false);
  let isFinished = useRef(false);
  let staminaReducer = useRef(0.14);
  let ifSecondStageComplete = useRef(false);
  let guiding = useRef(false);
  //
  const [charName, setCharName] = useState();
  const [numI, setNumI] = useState(0);
  const [numJ, setNumJ] = useState(0);
  const [wrapMastOpacity, setWrapMastOpacity] = useState(0);
  const [textBoxLeftText, setTextBoxLeftText] = useState("");
  const [textBoxRightText, setTextBoxRightText] = useState("");
  const [sixthStageGoing, setSixthStageGoing] = useState(false);
  const [save, setSave] = useState(0);
  //

  let textTranslation = {
    en:{
      stamina:"STAMINA",
    },
    ru:{
      stamina:"ВЫНОСЛИВОСТЬ",
    }
  }

  useEffect(() => {
  });


  let dialogEducationFirst, dialogEducation, dialogEducationSkip, lowerSpeedArr, secondStageArr, thirdStageArr, fourthStageArr, fifthStageArr, sixthStageArr, finalStageArr;
  useMemo(() => {
    if(language == "en"){
      dialogEducationFirst = JSON.parse(JSON.stringify(dialogEducationFirstEn));
      dialogEducation = JSON.parse(JSON.stringify(dialogEducationEn));
      dialogEducationSkip = JSON.parse(JSON.stringify(dialogEducationSkipEn));
      lowerSpeedArr = JSON.parse(JSON.stringify(lowerSpeedArrEn));
      secondStageArr = JSON.parse(JSON.stringify(secondStageArrEn));
      thirdStageArr = JSON.parse(JSON.stringify(thirdStageArrEn));
      fourthStageArr = JSON.parse(JSON.stringify(fourthStageArrEn));
      fifthStageArr = JSON.parse(JSON.stringify(fifthStageArrEn));
      sixthStageArr = JSON.parse(JSON.stringify(sixthStageArrEn));
      finalStageArr = JSON.parse(JSON.stringify(finalStageArrEn));
    }else if(language == "ru"){
      dialogEducationFirst = JSON.parse(JSON.stringify(dialogEducationFirstRu));
      dialogEducation = JSON.parse(JSON.stringify(dialogEducationRu));
      dialogEducationSkip = JSON.parse(JSON.stringify(dialogEducationSkipRu));
      lowerSpeedArr = JSON.parse(JSON.stringify(lowerSpeedArrRu));
      secondStageArr = JSON.parse(JSON.stringify(secondStageArrRu));
      thirdStageArr = JSON.parse(JSON.stringify(thirdStageArrRu));
      fourthStageArr = JSON.parse(JSON.stringify(fourthStageArrRu));
      fifthStageArr = JSON.parse(JSON.stringify(fifthStageArrRu));
      sixthStageArr = JSON.parse(JSON.stringify(sixthStageArrRu));
      finalStageArr = JSON.parse(JSON.stringify(finalStageArrRu));
    }
  });

    useEffect(() => {
      document.addEventListener('deviceready', deviceReadyFunc, false);
      function deviceReadyFunc() {
        document.addEventListener('backbutton', onBackButton, false);
      }
      function onBackButton(e) {
        e.preventDefault();
        goToMenu();
      }
      return () => {
        document.removeEventListener('deviceready', deviceReadyFunc, false);
        document.removeEventListener('backbutton', onBackButton, false);
      }
    },[]);

  useEffect(() => {
    start();
    async function start(){
      if(state.current[step] == undefined){
        state.current.splice(step, 1, {tryNum:tryNum.current, educationProcess:educationProcess.current, finished:false})
      }else{
        if(state.current[step]["tryNum"]){
          tryNum.current = state.current[step]["tryNum"];
        }
        if(state.current[step]["educationProcess"]){
          educationProcess.current = state.current[step]["educationProcess"];
        }
      }
      if(isLS){
      localStorage.setItem('stateSC1', JSON.stringify(state.current));
    }
    let difficultyCheck = JSON.parse(state.current[step-1]["savedAnswers"]);
    if(difficultyCheck[difficultyCheck.length-1][1] == "0"){
      staminaReducer.current = 0.145;
    }else if(difficultyCheck[difficultyCheck.length-1][1]  == "1"){
      staminaReducer.current = 0.13;
    }else if(difficultyCheck[difficultyCheck.length-1][1]  == "2"){
      staminaReducer.current = 0.10;
    }
    await loadImgs();
    await waitBGImg();
    if(window.innerWidth/window.innerHeight <= 0.5625){
      let lowing = bgRef.current.naturalHeight/bgRef.current.clientHeight;
      let bgPositionZero = (1080/lowing - window.innerWidth)/2 *-1;
      bgRef.current.style.transform = "translate("+bgPositionZero+"px, 0)";
      handRef.current.style.transform = "translate("+bgPositionZero+"px, 0)";
    }else{
      let lowing = bgRef.current.naturalHeight/bgRef.current.clientHeight;
      let heightIncrease = window.innerWidth/(1080/lowing);
      let heightPx = bgRef.current.clientHeight*heightIncrease+"px";
      bgRef.current.style.height = heightPx;
      handRef.current.style.height = heightPx;
    }
      bgAnimation();
      await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
      if(tryNum.current == 0){
        talking(dialogEducationFirst);
      }else if(tryNum.current !== 0 && educationProcess.current){
        talking(dialogEducationSkip);
      }else if(tryNum.current !== 0 && !educationProcess.current){
        talking(dialogEducation);
      }
      //wrap.current.style.zIndex = 0;
    }
},[]);
useEffect(() => {
    if(isLS){
    localStorage.setItem('achievementsSave', JSON.stringify(achievementsSave.current));
  }
},[saveAchievements]);

useEffect(() => {
      state.current.splice(step, 1, {tryNum:tryNum.current, educationProcess:educationProcess.current, finished:isFinished.current})
    if(isLS){
    localStorage.setItem('stateSC1', JSON.stringify(state.current));
  }
},[save]);


function loadImgs(){
  return new Promise(async (resolve, reject) => {
let image0 = new Image();
let image1 = new Image();
image0.src = background;
image1.src = hand;
image0.onload = () => {
window[background] = image0;
}
image1.onload = () => {
window[hand] = image1;
resolve();
return;
}
});
}

let ifGameFailed = false;
async function gameFailed(lackOfStamina, time){
  if(!ifGameFailed){
  ifGameFailed = true;
  tryNum.current++;
  setSave(previous => previous + 1);
  await waitingFunc(time);
  if(tryNum.current<5 && !lackOfStamina){
    if(state.current[step+1] !== undefined){
      state.current.splice(step+1, 1, {numI:0, numJ:0, savedAnswers:JSON.stringify([])})
    }
    nextNovel();
  }else if(tryNum.current<5 && lackOfStamina){
    if(state.current[step+2] !== undefined){
      state.current.splice(step+2, 1, {numI:0, numJ:0, savedAnswers:JSON.stringify([])})
    }
    nextNovel(2);
  }else if(tryNum.current>=5){
    nextNovel(3);
  }
}
}

async function waitBGImg(skip){
  if(skip){
    return;
  }
  return new Promise(async (resolve, reject) => {
    let loaded = false;
    while(!loaded) {
checkifPicLoaded();
await waitingFunc(16);
}
resolve();
    async function checkifPicLoaded(){
      if(exit.current){
        return;
      }
        if(!bgRef.current.complete || (bgRef.current.naturalWidth < 1) || (bgRef.current.naturalHeight < 1)){
          return;
        }else{
          await waitingFunc(16);
          loaded=true;
          return;
        }
      }
});
}

function bgAnimation(){
  if(exit.current){
    return;
  }
  let animationShift = bgRef.current.clientWidth/25;
  let bgPositionZero = (animationShift - document.body.clientWidth)/2 *-1;
  animationBGPosition.current = bgPositionZero;
  let iterations = 0;
  anim();
  function anim(){
    if(exit.current){
      return;
    }
    iterations++;
    animationBGPosition.current -=animationShift;
    if(iterations == 25){
      iterations = 0;
      animationBGPosition.current = bgPositionZero;
    }
    bgRef.current.style.transform = "translate("+animationBGPosition.current+"px, 0)";
    setTimeout(anim,36-parseInt(range.current.value/2.5));
  }
}
function handAnimation(){
  if(exit.current){
    return;
  }
  let animationShift = bgRef.current.clientWidth/25;
  let bgPositionZero = (animationShift - document.body.clientWidth)/2 *-1;
  animationHandPosition.current = bgPositionZero;
  let iterations = 0;
  anim();
  function anim(){
    if(exit.current){
      return;
    }
    iterations++;
    animationHandPosition.current -=animationShift;
    if(iterations == 25){
      iterations = 0;
      animationHandPosition.current = bgPositionZero;
    }
    handRef.current.style.transform = "translate("+animationHandPosition.current+"px, 0)";
    setWrapMastOpacity(range.current.value/100*3.6);
    if(!stopHandAnimation.current){
    setTimeout(anim,41-parseInt(range.current.value));
  }else{
    return;
  }
  }
}

async function staminaHandler(){
  if(exit.current){
    return;
  }
  if(!guiding.current){
    if(range.current.value >= 7){
    staminaLeft.current -= staminaReducer.current;
    }else{
      if(ifSecondStageComplete.current){
        staminaLeft.current += staminaReducer.current/2;
      }else{
        staminaLeft.current -= staminaReducer.current/2;
      }
    }
  }

  //staminaLeft.current -= staminaReducer.current;
  if(staminaLeft.current > 100){
    staminaLeft.current = 100;
  }else if(staminaLeft.current < 0){
  staminaLeft.current = 0;
  stamina.current.style.transform = "translate("+(staminaLeft.current-100)/2+"%, 0) scale("+staminaLeft.current + "%"+", 1)";
  range.current.disabled = true;
  await changeSetting(range,"current.value", 0, "", 0.3);
  stopHandAnimation.current = true;
  gameFailed(true, 500);
  return;
  }
  stamina.current.style.transform = "translate("+(staminaLeft.current-100)/2+"%, 0) scale("+staminaLeft.current + "%"+", 1)";
  if(parseInt(staminaLeft.current) == 70){
    stamina.current.style.background = "#ffc71f";
  }
  if(parseInt(staminaLeft.current) == 71){
    stamina.current.style.background = "#04db19";
  }
  if(parseInt(staminaLeft.current) == 30){
    stamina.current.style.background = "#fc232b";
  }
  if(parseInt(staminaLeft.current) == 31){
    stamina.current.style.background = "#ffc71f";
  }
    setTimeout(staminaHandler,100-parseInt(range.current.value));
}


function talking(dialog){
if(exit.current){
  return;
}
  return new Promise(async (resolve, reject) => {
  for(let i = 0; i<dialog.length; i++){
    for(let j = 0; j<dialog[i]["phrases"].length; j++){
    if(dialog[i]["phrases"][j]["text"]){
      await textAppearing(dialog[i]["phrases"][j]["text"],dialog[i]["position"], dialog[i]["char"]);
      if(dialog[i]["phrases"][j]["rangeAppears"]){
            await waitingFunc(1000);
            range.current.style.display = "block";
            await changeSetting(range,"current.style.opacity", 1, "", 0.02);
            firstStageEd();
            return;
          }
          if(dialog[i]["phrases"][j]["interfaceAppears"]){
                await waitingFunc(1000);
                range.current.style.display = "block";
                parametrs.current.style.display = "block";
                parametrs.current.style.transform = "scale(1)";
                changeSetting(range,"current.style.opacity", 1, "", 0.02);
                await changeSetting(parametrs,"current.style.opacity", 1, "", 0.02);
                staminaHandler();
                secondStage();
                return;
              }
        await waitin();
      await textDisappearing();
    }else if(dialog[i]["phrases"][j]["animationStart"]){
      handAnimation();
      await changeSetting(range,"current.value", dialog[i]["phrases"][j]["animationSpeed"], "", 0.2);
      await waitingFunc(500);
    }
  }
  }
  textBoxCover.current.style.display = "none";
  resolve();
});
}



//FIRST stage

let firstStageComplete = false;
let firstStageBadEnd = false;
let firstStageWrong = false;
async function firstStageEd(){
  if(exit.current){
    return;
  }
  let textChange = false;
  if(parseInt(range.current.value) <= 5 && !firstStageBadEnd){
    if(prevSpeed.current[0] == "justRight"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 10){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 3){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      if(prevSpeed.current[0] == "changedSpeed" && prevSpeed.current[2] == null){
        await textDisappearing();
        if(language == "en"){
          await textAppearing("Yeah, just like that","center", "Stacy");
        }else if(language == "ru"){
          await textAppearing("Ага, вот так вот","center", "Стейси");
        }
        await waitingFunc(500);
      }
      prevSpeed.current[0] = "justRight";
      prevSpeed.current[2] = 0;
    }
    if(textChange){
      textChange = false;
      if(lowerSpeedArr[0][0]["phrases"][0]["stageComplete"]){
        firstStageComplete=true;
      }
      await textDisappearing();
    await textAppearing(lowerSpeedArr[0][0]["phrases"][0]["text"],lowerSpeedArr[0][0]["position"], lowerSpeedArr[0][0]["char"]);
    if(lowerSpeedArr[0][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(lowerSpeedArr[0][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(lowerSpeedArr[0][0]["phrases"][0]["staminaAppear"]){
      parametrs.current.style.display = "block";
      changeSetting(parametrs,"current.style.opacity", 1, "", 0.02);
      await changeSetting(parametrs,"current.style.transform", 1, "scale", 0.01, false, true);
      staminaHandler();
    }
    if(lowerSpeedArr[0][0]["phrases"][0]["wait"]){
      await waitingFunc(lowerSpeedArr[0][0]["phrases"][0]["wait"]);
    }
    if(lowerSpeedArr[0][0]["phrases"][0]["nextStage"]){
      educationProcess.current=true;
      setSave(previous => previous + 1);
      secondStage();
      return;
    }
    lowerSpeedArr[0][0]["phrases"].splice(0, 1);
    if(lowerSpeedArr[0][0]["phrases"].length == 0){
      lowerSpeedArr[0].splice(0, 1);
    }
    }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) >= 18 && !firstStageComplete) || firstStageBadEnd){
  if(prevSpeed.current[0] == "tooMuch"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 5){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!firstStageBadEnd){
    prevSpeed.current[0] = "tooMuch";
    prevSpeed.current[2] = 0;
  }
  }
  if(textChange){
    textChange = false;
    await textDisappearing();
    let num = 1;
    if(firstStageWrong){
      num = 3;
    }
  await textAppearing(lowerSpeedArr[num][0]["phrases"][0]["text"],lowerSpeedArr[num][0]["position"], lowerSpeedArr[num][0]["char"]);
  if(lowerSpeedArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(lowerSpeedArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(lowerSpeedArr[num][0]["phrases"][0]["wait"]);
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    firstStageBadEnd = true;
    return;
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["checkPoint"]){
    firstStageWrong = true;
  }
  lowerSpeedArr[num][0]["phrases"].splice(0, 1);
  if(lowerSpeedArr[num][0]["phrases"].length == 0){
    lowerSpeedArr[num].splice(0, 1);
  }
  }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) < 18 && parseInt(range.current.value) > 5  && !firstStageComplete) || firstStageBadEnd){
  if(prevSpeed.current[0] == "almostThere"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 8){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!firstStageBadEnd){
    prevSpeed.current[0] = "almostThere";
    prevSpeed.current[2] = 0;
    }
  }
  if(textChange){
    textChange = false;
  await textDisappearing();
  let num = 2;
  if(firstStageWrong){
    num = 3;
  }
  await textAppearing(lowerSpeedArr[num][0]["phrases"][0]["text"],lowerSpeedArr[num][0]["position"], lowerSpeedArr[num][0]["char"]);
  if(lowerSpeedArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(lowerSpeedArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(lowerSpeedArr[num][0]["phrases"][0]["wait"]);
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    firstStageBadEnd = true;
    return;
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["checkPoint"]){
    firstStageWrong = true;
  }
  lowerSpeedArr[num][0]["phrases"].splice(0, 1);
  if(lowerSpeedArr[num][0]["phrases"].length == 0){
    lowerSpeedArr[num].splice(0, 1);
  }
  }
}
if(exit.current){
  return;
}
if(parseInt(range.current.value) > 5 && firstStageComplete){
  if(prevSpeed.current[0] == "changedSpeed"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 6){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!firstStageBadEnd){
    prevSpeed.current[0] = "changedSpeed";
    prevSpeed.current[2] = 0;
    }
  }
  if(textChange){
    textChange = false;
  await textDisappearing();
  let num = 4;
  await textAppearing(lowerSpeedArr[num][0]["phrases"][0]["text"],lowerSpeedArr[num][0]["position"], lowerSpeedArr[num][0]["char"]);
  if(lowerSpeedArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(lowerSpeedArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(lowerSpeedArr[num][0]["phrases"][0]["wait"]);
  }
  if(lowerSpeedArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    firstStageBadEnd = true;
    return;
  }
  lowerSpeedArr[num][0]["phrases"].splice(0, 1);
  if(lowerSpeedArr[num][0]["phrases"].length == 0){
    lowerSpeedArr[num].splice(0, 1);
  }
  }
}
setTimeout(firstStageEd, 200);
}

//SECOND stage
let secondStageComplete = false;
let secondStageBadEnd = false;
let secondStageWrong = false;
async function secondStage(){
  if(exit.current){
    return;
  }
  let textChange = false;
  if((parseInt(range.current.value) < 17 && parseInt(range.current.value)) > 7 && !secondStageBadEnd){
    if(prevSpeed.current[0] == "justRight"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 6){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 3){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      if(prevSpeed.current[0] == "changedSpeed" && prevSpeed.current[2] == null){
        await textDisappearing();
        if(language == "en"){
          await textAppearing("Uh-huh, right here...","center", "Stacy");
        }else if(language == "ru"){
          await textAppearing("Угу, вот таак","center", "Стейси");
        }
        await waitingFunc(500);
      }
      prevSpeed.current[0] = "justRight";
      prevSpeed.current[2] = 0;
    }
    if(textChange){
      textChange = false;
      if(secondStageArr[0][0]["phrases"][0]["stageComplete"]){
        secondStageComplete=true;
      }
      await textDisappearing();
    await textAppearing(secondStageArr[0][0]["phrases"][0]["text"],secondStageArr[0][0]["position"], secondStageArr[0][0]["char"]);
    if(secondStageArr[0][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(secondStageArr[0][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(secondStageArr[0][0]["phrases"][0]["staminaAppear"]){
      parametrs.current.style.display = "block";
      await changeSetting(parametrs,"current.style.opacity", 1, "", 0.02);
    }
    if(secondStageArr[0][0]["phrases"][0]["wait"]){
      await waitingFunc(secondStageArr[0][0]["phrases"][0]["wait"]);
    }
    if(secondStageArr[0][0]["phrases"][0]["nextStage"]){
      ifSecondStageComplete.current = true;
      thirdStage();
      return;
    }
    secondStageArr[0][0]["phrases"].splice(0, 1);
    if(secondStageArr[0][0]["phrases"].length == 0){
      secondStageArr[0].splice(0, 1);
    }
    }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) >= 17 && !secondStageComplete) || secondStageBadEnd){
  if(prevSpeed.current[0] == "tooMuch"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 3){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!secondStageBadEnd){
    prevSpeed.current[0] = "tooMuch";
    prevSpeed.current[2] = 0;
  }
  }
  if(textChange){
    textChange = false;
    await textDisappearing();
    let num = 1;
    if(secondStageWrong){
      num = 3;
    }
  await textAppearing(secondStageArr[num][0]["phrases"][0]["text"],secondStageArr[num][0]["position"], secondStageArr[num][0]["char"]);
  if(secondStageArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(secondStageArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(secondStageArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(secondStageArr[num][0]["phrases"][0]["wait"]);
  }
  if(secondStageArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    secondStageBadEnd = true;
    return;
  }
  if(secondStageArr[num][0]["phrases"][0]["checkPoint"]){
    secondStageWrong = true;
  }
  secondStageArr[num][0]["phrases"].splice(0, 1);
  if(secondStageArr[num][0]["phrases"].length == 0){
    secondStageArr[num].splice(0, 1);
  }
  }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) <= 7  && !secondStageComplete) || secondStageBadEnd){
  if(prevSpeed.current[0] == "tooSlow"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 8){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!secondStageBadEnd){
    prevSpeed.current[0] = "tooSlow";
    prevSpeed.current[2] = 0;
    }
  }
  if(textChange){
    textChange = false;
  await textDisappearing();
  let num = 2;
  if(secondStageWrong){
    num = 3;
  }
  await textAppearing(secondStageArr[num][0]["phrases"][0]["text"],secondStageArr[num][0]["position"], secondStageArr[num][0]["char"]);
  if(secondStageArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(secondStageArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(secondStageArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(secondStageArr[num][0]["phrases"][0]["wait"]);
  }
  if(secondStageArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    secondStageBadEnd = true;
    return;
  }
  if(secondStageArr[num][0]["phrases"][0]["checkPoint"]){
    secondStageWrong = true;
  }
  secondStageArr[num][0]["phrases"].splice(0, 1);
  if(secondStageArr[num][0]["phrases"].length == 0){
    secondStageArr[num].splice(0, 1);
  }
  }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) >= 17 || parseInt(range.current.value) <= 7) && secondStageComplete){
  if(prevSpeed.current[0] == "changedSpeed"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 6){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!secondStageBadEnd){
    prevSpeed.current[0] = "changedSpeed";
    prevSpeed.current[2] = 0;
    }
  }
  if(textChange){
    textChange = false;
  await textDisappearing();
  let num = 4;
  await textAppearing(secondStageArr[num][0]["phrases"][0]["text"],secondStageArr[num][0]["position"], secondStageArr[num][0]["char"]);
  if(secondStageArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(secondStageArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(secondStageArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(secondStageArr[num][0]["phrases"][0]["wait"]);
  }
  if(secondStageArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    secondStageBadEnd = true;
    return;
  }
  secondStageArr[num][0]["phrases"].splice(0, 1);
  if(secondStageArr[num][0]["phrases"].length == 0){
    secondStageArr[num].splice(0, 1);
  }
  }
}
setTimeout(secondStage, 200);
}


//THRID stage
let thirdStageComplete = false;
let thirdStageBadEnd = false;
let thirdStageWrong = false;
async function thirdStage(){
  if(exit.current){
    return;
  }
  let textChange = false;
  if((parseInt(range.current.value) < 7 && parseInt(range.current.value) > 3) && !thirdStageBadEnd){
    if(prevSpeed.current[0] == "justRight"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 9){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 3){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      if(prevSpeed.current[0] == "changedSpeed" && prevSpeed.current[2] == null){
        await textDisappearing();
        if(language == "en"){
          await textAppearing("Mhmmm..","center", "Stacy");
        }else if(language == "ru"){
          await textAppearing("Мхммм..","center", "Стейси");
        }
        await waitingFunc(500);
      }
      prevSpeed.current[0] = "justRight";
      prevSpeed.current[2] = 0;
    }
    if(textChange){
      textChange = false;
      if(thirdStageArr[0][0]["phrases"][0]["stageComplete"]){
        thirdStageComplete=true;
      }
      await textDisappearing();
    await textAppearing(thirdStageArr[0][0]["phrases"][0]["text"],thirdStageArr[0][0]["position"], thirdStageArr[0][0]["char"]);
    if(thirdStageArr[0][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(thirdStageArr[0][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(thirdStageArr[0][0]["phrases"][0]["staminaAppear"]){
      parametrs.current.style.display = "block";
      await changeSetting(parametrs,"current.style.opacity", 1, "", 0.02);
    }
    if(thirdStageArr[0][0]["phrases"][0]["wait"]){
      await waitingFunc(thirdStageArr[0][0]["phrases"][0]["wait"]);
    }
    if(thirdStageArr[0][0]["phrases"][0]["nextStage"]){
      fourthStage()
      return;
    }
    thirdStageArr[0][0]["phrases"].splice(0, 1);
    if(thirdStageArr[0][0]["phrases"].length == 0){
      thirdStageArr[0].splice(0, 1);
    }
    }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) < 17 && parseInt(range.current.value) >= 7  && !thirdStageComplete) || thirdStageBadEnd){
  if(prevSpeed.current[0] == "almostThere"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 7){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!thirdStageBadEnd){
    prevSpeed.current[0] = "almostThere";
    prevSpeed.current[2] = 0;
    }
  }
  if(textChange){
    textChange = false;
  await textDisappearing();
  let num = 2;
  if(thirdStageWrong){
    num = 4;
  }
  await textAppearing(thirdStageArr[num][0]["phrases"][0]["text"],thirdStageArr[num][0]["position"], thirdStageArr[num][0]["char"]);
  if(thirdStageArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(thirdStageArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(thirdStageArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(thirdStageArr[num][0]["phrases"][0]["wait"]);
  }
  if(thirdStageArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    thirdStageBadEnd = true;
    return;
  }
  if(thirdStageArr[num][0]["phrases"][0]["checkPoint"]){
    thirdStageWrong = true;
  }
  thirdStageArr[num][0]["phrases"].splice(0, 1);
  if(thirdStageArr[num][0]["phrases"].length == 0){
    thirdStageArr[num].splice(0, 1);
  }
  }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) >= 17 && !thirdStageComplete) || thirdStageBadEnd){
  if(prevSpeed.current[0] == "tooMuch"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 3){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 4){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!thirdStageBadEnd){
    prevSpeed.current[0] = "tooMuch";
    prevSpeed.current[2] = 0;
  }
  }
  if(textChange){
    textChange = false;
    await textDisappearing();
    let num = 1;
    if(thirdStageWrong){
      num = 4;
    }
  await textAppearing(thirdStageArr[num][0]["phrases"][0]["text"],thirdStageArr[num][0]["position"], thirdStageArr[num][0]["char"]);
  if(thirdStageArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(thirdStageArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(thirdStageArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(thirdStageArr[num][0]["phrases"][0]["wait"]);
  }
  if(thirdStageArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    thirdStageBadEnd = true;
    return;
  }
  if(thirdStageArr[num][0]["phrases"][0]["checkPoint"]){
    thirdStageWrong = true;
  }
  thirdStageArr[num][0]["phrases"].splice(0, 1);
  if(thirdStageArr[num][0]["phrases"].length == 0){
    thirdStageArr[num].splice(0, 1);
  }
  }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) <= 3  && !thirdStageComplete) || thirdStageBadEnd){
  if(prevSpeed.current[0] == "tooSlow"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 10){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!thirdStageBadEnd){
    prevSpeed.current[0] = "tooSlow";
    prevSpeed.current[2] = 0;
    }
  }
  if(textChange){
    textChange = false;
  await textDisappearing();
  let num = 3;
  if(thirdStageWrong){
    num = 4;
  }
  await textAppearing(thirdStageArr[num][0]["phrases"][0]["text"],thirdStageArr[num][0]["position"], thirdStageArr[num][0]["char"]);
  if(thirdStageArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(thirdStageArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(thirdStageArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(thirdStageArr[num][0]["phrases"][0]["wait"]);
  }
  if(thirdStageArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    thirdStageBadEnd = true;
    return;
  }
  if(thirdStageArr[num][0]["phrases"][0]["checkPoint"]){
    thirdStageWrong = true;
  }
  thirdStageArr[num][0]["phrases"].splice(0, 1);
  if(thirdStageArr[num][0]["phrases"].length == 0){
    thirdStageArr[num].splice(0, 1);
  }
  }
}
if(exit.current){
  return;
}
if((parseInt(range.current.value) >= 7 || parseInt(range.current.value) <= 3) && thirdStageComplete){
  if(prevSpeed.current[0] == "changedSpeed"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[2] != null){
      prevSpeed.current[2]++;
    }
    if(prevSpeed.current[1] == 6){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
    if(prevSpeed.current[2] == 3){
      prevSpeed.current[2] = null;
      prevSpeed.current[1] = 0;
      textChange = true;
    }
  }else{
    if(!thirdStageBadEnd){
    prevSpeed.current[0] = "changedSpeed";
    prevSpeed.current[2] = 0;
    }
  }
  if(textChange){
    textChange = false;
  await textDisappearing();
  let num = 5;
  await textAppearing(thirdStageArr[num][0]["phrases"][0]["text"],thirdStageArr[num][0]["position"], thirdStageArr[num][0]["char"]);
  if(thirdStageArr[num][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(thirdStageArr[num][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(thirdStageArr[num][0]["phrases"][0]["wait"]){
    await waitingFunc(thirdStageArr[num][0]["phrases"][0]["wait"]);
  }
  if(thirdStageArr[num][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    thirdStageBadEnd = true;
    return;
  }
  thirdStageArr[num][0]["phrases"].splice(0, 1);
  if(thirdStageArr[num][0]["phrases"].length == 0){
    thirdStageArr[num].splice(0, 1);
  }
  }
}
setTimeout(thirdStage, 200);
}


//FOURTH stage

let fourthStageComplete = false;
let fourthStageBadEnd = false;
let fourthStageWrong = false;

async function fourthStage(){
  if(exit.current){
    return;
  }
  let textChange = false;
  if((parseInt(range.current.value) > 24 || fourthStageComplete) && !fourthStageBadEnd){
    if(prevSpeed.current[0] == "justRight"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 5){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 5){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      prevSpeed.current[0] = "justRight";
      prevSpeed.current[2] = 0;
    }
    if(textChange){
      textChange = false;
      if(fourthStageArr[0][0]["phrases"][0]["stageComplete"]){
        fourthStageComplete=true;
      }
      await textDisappearing();
    await textAppearing(fourthStageArr[0][0]["phrases"][0]["text"],fourthStageArr[0][0]["position"], fourthStageArr[0][0]["char"]);
    if(fourthStageArr[0][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(fourthStageArr[0][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(fourthStageArr[0][0]["phrases"][0]["staminaAppear"]){
      parametrs.current.style.display = "block";
      await changeSetting(parametrs,"current.style.opacity", 1, "", 0.02);
    }
    if(fourthStageArr[0][0]["phrases"][0]["wait"]){
      await waitingFunc(fourthStageArr[0][0]["phrases"][0]["wait"]);
    }
    if(fourthStageArr[0][0]["phrases"][0]["nextStage"]){
      fifthStage();
      return;
    }
    fourthStageArr[0][0]["phrases"].splice(0, 1);
    if(fourthStageArr[0][0]["phrases"].length == 0){
      fourthStageArr[0].splice(0, 1);
    }
    }
    if(exit.current){
      return;
    }
}else if((parseInt(range.current.value) <= 24  && !fourthStageComplete) || fourthStageBadEnd){
    if(prevSpeed.current[0] == "tooSlow"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 7){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 7){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      if(!thirdStageBadEnd){
      prevSpeed.current[0] = "tooSlow";
      prevSpeed.current[2] = 0;
      }
    }
    if(textChange){
      textChange = false;
    await textDisappearing();
    let num = 1;
    if(fourthStageWrong){
      num = 4;
    }
    await textAppearing(fourthStageArr[num][0]["phrases"][0]["text"],fourthStageArr[num][0]["position"], fourthStageArr[num][0]["char"]);
    if(fourthStageArr[num][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(fourthStageArr[num][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(fourthStageArr[num][0]["phrases"][0]["wait"]){
      await waitingFunc(fourthStageArr[num][0]["phrases"][0]["wait"]);
    }
    if(fourthStageArr[num][0]["phrases"][0]["badEnd"]){
      gameFailed(false,1000);
      fourthStageBadEnd = true;
      return;
    }
    if(fourthStageArr[num][0]["phrases"][0]["checkPoint"]){
      fourthStageWrong = true;
    }
    fourthStageArr[num][0]["phrases"].splice(0, 1);
    if(fourthStageArr[num][0]["phrases"].length == 0){
      fourthStageArr[num].splice(0, 1);
    }
    }
}


setTimeout(fourthStage, 200);
}

//FIFTH stage

let fifthStageComplete = false;
let fifthStageBadEnd = false;
let fifthStageWrong = false;

async function fifthStage(){
  if(exit.current){
    return;
  }
  let textChange = false;
  if((parseInt(range.current.value) <= 2 || fifthStageComplete) && !fifthStageBadEnd){
    if(prevSpeed.current[0] == "justRight"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 5){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 5){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      prevSpeed.current[0] = "justRight";
      prevSpeed.current[2] = 0;
    }
    if(textChange){
      textChange = false;
      if(fifthStageArr[0][0]["phrases"][0]["stageComplete"]){
        fifthStageComplete=true;
      }
      await textDisappearing();
    await textAppearing(fifthStageArr[0][0]["phrases"][0]["text"],fifthStageArr[0][0]["position"], fifthStageArr[0][0]["char"]);
    if(fifthStageArr[0][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(fifthStageArr[0][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(fifthStageArr[0][0]["phrases"][0]["staminaAppear"]){
      parametrs.current.style.display = "block";
      await changeSetting(parametrs,"current.style.opacity", 1, "", 0.02);
    }
    if(fifthStageArr[0][0]["phrases"][0]["guideStart"]){
      await waitingFunc(300);
      guiding.current = true;
      guide();
    }
    if(fifthStageArr[0][0]["phrases"][0]["guideFinish"]){
      guiding.current = false;
    }
    if(fifthStageArr[0][0]["phrases"][0]["wait"]){
      await waitingFunc(fifthStageArr[0][0]["phrases"][0]["wait"]);
    }
    if(fifthStageArr[0][0]["phrases"][0]["nextStage"]){
      prevSpeed.current[0] = undefined;
      prevSpeed.current[1] = 0;
      prevSpeed.current[2] = 0;
      setSixthStageGoing(prev => !prev);
      sixthStage();
      return;
    }
    fifthStageArr[0][0]["phrases"].splice(0, 1);
    if(fifthStageArr[0][0]["phrases"].length == 0){
      fifthStageArr[0].splice(0, 1);
    }
    }
    if(exit.current){
      return;
    }
}else if((parseInt(range.current.value) > 2  && !fifthStageComplete) || fifthStageBadEnd){
    if(prevSpeed.current[0] == "tooSlow"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 7){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 7){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      if(!thirdStageBadEnd){
      prevSpeed.current[0] = "tooSlow";
      prevSpeed.current[2] = 0;
      }
    }
    if(textChange){
      textChange = false;
    await textDisappearing();
    let num = 1;
    if(fifthStageWrong){
      num = 4;
    }
    await textAppearing(fifthStageArr[num][0]["phrases"][0]["text"],fifthStageArr[num][0]["position"], fifthStageArr[num][0]["char"]);
    if(fifthStageArr[num][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(fifthStageArr[num][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(fifthStageArr[num][0]["phrases"][0]["wait"]){
      await waitingFunc(fifthStageArr[num][0]["phrases"][0]["wait"]);
    }
    if(fifthStageArr[num][0]["phrases"][0]["badEnd"]){
      gameFailed(false,1000);
      fifthStageBadEnd = true;
      return;
    }
    if(fifthStageArr[num][0]["phrases"][0]["checkPoint"]){
      fifthStageWrong = true;
    }
    fifthStageArr[num][0]["phrases"].splice(0, 1);
    if(fifthStageArr[num][0]["phrases"].length == 0){
      fifthStageArr[num].splice(0, 1);
    }
    }
}


setTimeout(fifthStage, 200);
}

async function guide(){
  if(exit.current){
    return;
  }
  if(guiding.current){
    range.current.disabled = true;
    await changeSetting(range,"current.value", 27, "", 0.6);
    await waitingFunc(50);
    await changeSetting(range,"current.value", 0, "", 0.6);
    setTimeout(guide, 100);
  }else{
    await changeSetting(range,"current.value", 27, "", 0.5);
    await waitingFunc(100);
    await changeSetting(range,"current.value", 0, "", 0.4);
    range.current.disabled = false;
    return;
  }
}


//SIXTH stage
function sixthStageSpeedChecker(){
  if(exit.current){
    return;
  }
  if(range.current.value < 6 && (prevPos.current == "top" || prevPos.current == undefined)){
     bottomTime.current = new Date();
     prevPos.current = "bottom";
     if(topTime){
       speed.current = bottomTime.current - topTime.current;
     }
  }
  if(range.current.value > 22 && (prevPos.current == "bottom" || prevPos.current == undefined)){
     topTime.current = new Date();
     prevPos.current = "top";
     if(bottomTime.current){
       speed.current = topTime.current - bottomTime.current;
     }
  }
}


//SIXTH stage

let sixthStageComplete = false;
let sixthStageSpeedFixed = false;
async function sixthStage(){
  if(exit.current){
    return;
  }

  let textChange = false;
  if(speed.current == speedPrev.current){
      sixthStageSpeedFixed = true;
  }else{
    sixthStageSpeedFixed = false;
  }
  speedPrev.current = speed.current;
if(speed.current < 800 && !sixthStageSpeedFixed){
  if(prevSpeed.current[0] == "justRight"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[1] > 0){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
  }else{
    prevSpeed.current[0] = "justRight";
    prevSpeed.current[1] = 0;
  }
  if(textChange){
    textChange = false;
    if(sixthStageArr[0][0]["phrases"][0]["stageComplete"]){
      sixthStageComplete=true;
    }
    await textDisappearing();
  await textAppearing(sixthStageArr[0][0]["phrases"][0]["text"],sixthStageArr[0][0]["position"], sixthStageArr[0][0]["char"]);
  if(sixthStageArr[0][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(sixthStageArr[0][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(sixthStageArr[0][0]["phrases"][0]["wait"]){
    await waitingFunc(sixthStageArr[0][0]["phrases"][0]["wait"]);
  }
  if(sixthStageArr[0][0]["phrases"][0]["nextStage"]){
    finalStage();
    setSixthStageGoing(prev => !prev);
    return;
  }
  sixthStageArr[0][0]["phrases"].splice(0, 1);
  if(sixthStageArr[0][0]["phrases"].length == 0){
    sixthStageArr[0].splice(0, 1);
  }
  }
  if(exit.current){
    return;
  }
}else if(speed.current >= 800 && !sixthStageSpeedFixed){
  if(prevSpeed.current[0] == "tooSlow"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[1] > 0){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
  }else{
    prevSpeed.current[0] = "tooSlow";
    prevSpeed.current[1] = 0;
  }
  if(textChange){
    textChange = false;
    await textDisappearing();
  await textAppearing(sixthStageArr[1][0]["phrases"][0]["text"],sixthStageArr[1][0]["position"], sixthStageArr[1][0]["char"]);
  if(sixthStageArr[1][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(sixthStageArr[1][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(sixthStageArr[1][0]["phrases"][0]["wait"]){
    await waitingFunc(sixthStageArr[1][0]["phrases"][0]["wait"]);
  }
  if(sixthStageArr[1][0]["phrases"][0]["badEnd"]){
    if(state.current[step+1] !== undefined){
      state.current.splice(step+1, 1, {numI:0, numJ:0, savedAnswers:JSON.stringify([])})
    }
    gameFailed(false, 1000);
    return;
  }
  sixthStageArr[1][0]["phrases"].splice(0, 1);
  if(sixthStageArr[1][0]["phrases"].length == 0){
    sixthStageArr[1].splice(0, 1);
  }
  }
  if(exit.current){
    return;
  }
}else if(sixthStageSpeedFixed){
  if(prevSpeed.current[0] == "fixed"){
    prevSpeed.current[1]++;
    if(prevSpeed.current[1] > 1){
      textChange = true;
      prevSpeed.current[1] = 0;
    }
  }else{
    prevSpeed.current[0] = "fixed";
    prevSpeed.current[1] = 0;
  }

  if(textChange){
    textChange = false;
    await textDisappearing();
  await textAppearing(sixthStageArr[2][0]["phrases"][0]["text"],sixthStageArr[2][0]["position"], sixthStageArr[2][0]["char"]);
  if(sixthStageArr[2][0]["phrases"][0]["vibration"]){
    try{
      navigator.vibrate(sixthStageArr[2][0]["phrases"][0]["vibration"]);
  }catch(e){
    console.log(e);
  }
  }
  if(sixthStageArr[2][0]["phrases"][0]["wait"]){
    await waitingFunc(sixthStageArr[2][0]["phrases"][0]["wait"]);
  }
  if(sixthStageArr[2][0]["phrases"][0]["badEnd"]){
    gameFailed(false,1000);
    return;
  }
  sixthStageArr[2][0]["phrases"].splice(0, 1);
  if(sixthStageArr[2][0]["phrases"].length == 0){
    sixthStageArr[2].splice(0, 1);
  }
  }

}
  setTimeout(sixthStage, 1300);
}


//FINAL stage

let finalStageComplete = false;
let finalStageBadEnd = false;
let finalStageWrong = false;

async function finalStage(){
  if(exit.current){
    return;
  }
  let textChange = false;
  if((parseInt(range.current.value) > 26.6 || finalStageComplete) && !finalStageBadEnd){
    if(prevSpeed.current[0] == "justRight"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 4){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 4){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      prevSpeed.current[0] = "justRight";
      prevSpeed.current[2] = 0;
    }
    if(textChange){
      textChange = false;
      if(finalStageArr[0][0]["phrases"][0]["stageComplete"]){
        finalStageComplete=true;
      }
      if(finalStageArr[0][0]["phrases"][0]["passed"]){
        guiding.current = true;
        range.current.disabled = true;
        changeSetting(range,"current.style.opacity", 0, "", 0.02);
        await changeSetting(parametrs,"current.style.opacity", 0, "", 0.02);
      }
      await textDisappearing();
    await textAppearing(finalStageArr[0][0]["phrases"][0]["text"],finalStageArr[0][0]["position"], finalStageArr[0][0]["char"]);
    if(finalStageArr[0][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(finalStageArr[0][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(finalStageArr[0][0]["phrases"][0]["staminaAppear"]){
      parametrs.current.style.display = "block";
      await changeSetting(parametrs,"current.style.opacity", 1, "", 0.02);
    }
    if(finalStageArr[0][0]["phrases"][0]["wait"]){
      await waitingFunc(finalStageArr[0][0]["phrases"][0]["wait"]);
    }
    if(finalStageArr[0][0]["phrases"][0]["nextStage"]){
      isFinished.current = true;
      setSave(previous => previous + 1);
      nextNovel(6, 2700);
      return;
    }
    finalStageArr[0][0]["phrases"].splice(0, 1);
    if(finalStageArr[0][0]["phrases"].length == 0){
      finalStageArr[0].splice(0, 1);
    }
    }
    if(exit.current){
      return;
    }
}else if((parseInt(range.current.value) < 26.6  && !finalStageComplete) || finalStageBadEnd){
    if(prevSpeed.current[0] == "tooSlow"){
      prevSpeed.current[1]++;
      if(prevSpeed.current[2] != null){
        prevSpeed.current[2]++;
      }
      if(prevSpeed.current[1] == 5){
        textChange = true;
        prevSpeed.current[1] = 0;
      }
      if(prevSpeed.current[2] == 5){
        prevSpeed.current[2] = null;
        prevSpeed.current[1] = 0;
        textChange = true;
      }
    }else{
      if(!thirdStageBadEnd){
      prevSpeed.current[0] = "tooSlow";
      prevSpeed.current[2] = 0;
      }
    }
    if(textChange){
      textChange = false;
    await textDisappearing();
    let num = 1;
    if(finalStageWrong){
      num = 4;
    }
    await textAppearing(finalStageArr[num][0]["phrases"][0]["text"],finalStageArr[num][0]["position"], finalStageArr[num][0]["char"]);
    if(finalStageArr[num][0]["phrases"][0]["vibration"]){
      try{
        navigator.vibrate(finalStageArr[num][0]["phrases"][0]["vibration"]);
    }catch(e){
      console.log(e);
    }
    }
    if(finalStageArr[num][0]["phrases"][0]["wait"]){
      await waitingFunc(finalStageArr[num][0]["phrases"][0]["wait"]);
    }
    if(finalStageArr[num][0]["phrases"][0]["badEnd"]){
      gameFailed(false,1000);
      finalStageBadEnd = true;
      return;
    }
    if(finalStageArr[num][0]["phrases"][0]["checkPoint"]){
      finalStageWrong = true;
    }
    finalStageArr[num][0]["phrases"].splice(0, 1);
    if(finalStageArr[num][0]["phrases"].length == 0){
      finalStageArr[num].splice(0, 1);
    }
    }
}


setTimeout(finalStage, 200);
}




function waitingFunc(t, loadStop){
  return new Promise(async (resolve, reject) => {
      setTimeout(f,t);
    function f(){
      resolve();
      return;
    }
  });
}


async function goToMenu(){
    wrap.current.style.zIndex = "16";
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  try{
    navigator.vibrate(0);
}catch(e){
  console.log(e);
}
  exit.current=true;
  document.body.classList.remove("stop-scrolling");
  goMenu();
  return;
}

async function nextNovel(i, waitTime){
  wrap.current.style.zIndex = 16;
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.02);
  exit.current=true;
  if(!waitTime){
    waitTime = 600
  }
  if(i>1){
    for(let k=0;k<i;k++){
      if(state.current[step+k] == undefined){
        state.current.splice(step+k, 1, null)
      }
    }
  }
  if(i == 6){
    try{
      navigator.vibrate(0);
      navigator.vibrate([500, 100, 1000, 100, 300]);
  }catch(e){
    console.log(e);
  }
  }else{
    try{
      navigator.vibrate(0);
      navigator.vibrate([500]);
  }catch(e){
    console.log(e);
  }
  }
  await waitingFunc(waitTime);
  try{
    navigator.vibrate(0);
}catch(e){
  console.log(e);
}
  goNext(i);
  return;
}

async function waitin(){
  if(exit.current){
    return;
  }
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
function ff(){
  resolve();
}
});
}

function skipText(){
if(arrowBackVisible.current){
  clearTimeout(arrowBackVisible.current);
  backMenuDisappear();
}

if(texting.current){
  if(skipButton.current){
    stopTexting.current = true;
  }
}

}


async function setTextParameters(obj, setting, changeTo, speed, changeTo1, speed1, changeTo2, speed2, setting3, changeTo3, speed3, position){
  if(exit.current){
    return;
  }
  return new Promise(async (resolve, reject) => {
const props = setting
    .split(/[./[\]]/g)
    .filter(p => p);
const prop = props.pop();
const parent = props.reduce((result, key) => result[key], obj);

const props3 = setting3
    .split(/[./[\]]/g)
    .filter(p => p);
const prop3 = props3.pop();
const parent3 = props3.reduce((result, key) => result[key], obj);

changeTo = changeTo*document.body.clientWidth/100;
changeTo1 = changeTo1*document.body.clientHeight/100;
speed=2*1.7*document.body.clientWidth/100*hzAdjuster;
speed1=0.8*1.7*document.body.clientHeight/100*hzAdjuster;
speed2=0.04*1.7*hzAdjuster;
speed3=0.04*1.7*hzAdjuster;
let pre = parent[prop];
let preI,i,preI1,i1,preI2,i2;
if(pre !== "translate(0px) scale(1)" && pre.includes(",")){ //apple bug fix
preI = pre.split("translate(")[1];
i = Math.round(parseFloat(preI.split("px")[0]));
preI1 = parent[prop].split(", ")[1];
i1 = Math.round(preI1.split("px")[0]);
preI2 = parent[prop].split("scale(")[1];
i2 = Math.round(preI2.split(")")[0]);
}else{
  preI = pre.split("translate(")[1];
  i = Math.round(parseFloat(preI.split("px")[0]));
  i1=0;
  preI2 = parent[prop].split("scale(")[1];
  i2 = Math.round(preI2.split(")")[0]);
}
let i3 = Math.round(parent3[prop3]);
textAppear();
function textAppear(){
  if(exit.current){
    return;
  }
  if(i<changeTo){
    i+=speed;
    //i = parseFloat(i.toFixed(1));
    if(i>changeTo){
      i=changeTo;
    }
  }else if(i>changeTo){
    i-=speed;
  //  i = parseFloat(i.toFixed(1));
    if(i<changeTo){
      i=changeTo;
    }
  }
  if(i1<changeTo1){
    i1+=speed1;
    //i1 = parseFloat(i1.toFixed(1));
    if(i1>changeTo1 || (i==changeTo)){
      i1=changeTo1;
    }
  }else if(i1>changeTo1){
    i1-=speed1;
    //i1 = parseFloat(i1.toFixed(1));
    if(i1<changeTo1 || (i==changeTo)){
      i1=changeTo1;
    }
  }
  if(i2<changeTo2){
    i2+=speed2;
    //i2 = parseFloat(i2.toFixed(1));
    if(i2>changeTo2 || (i==changeTo)){
      i2=changeTo2;
    }
  }else if(i2>changeTo2){
    i2-=speed2;
  //  i2 = parseFloat(i2.toFixed(1));
    if(i2<changeTo2 || (i==changeTo)){
      i2=changeTo2;
    }
  }
  if(i3<changeTo3){
    i3+=speed3;
    //i3 = parseFloat(i3.toFixed(1));
    if(i3>changeTo3 || (i==changeTo)){
      i3=changeTo3;
    }
  }else if(i3>changeTo3){
    i3-=speed3;
    //i3 = parseFloat(i3.toFixed(1));
    if(i3<changeTo3 || (i==changeTo)){
      i3=changeTo3;
    }
  }
  if(position !== "center"){
    parent[prop] = "translate("+i+"px, "+i1+"px) scale("+i2+")";
  }else{
    parent[prop] = "translate(0px, "+i1+"px) scale("+i2+")";
  }
parent3[prop3] = i3;
if(i == changeTo){
  resolve();
  return;
}
  requestAnimationFrame(textAppear);
  return;
}
});
}

function changeSetting(obj, setting, changeTo, um, speed, char){
  if(exit.current){
    return;
  }
speed=speed*2.3*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    //
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      i = parseFloat(parent[prop].split("(")[1].split(")")[0]);
    }else{
      i = parseFloat(parent[prop]);
    }
    let slowDownTrigger = 0;
  //  if(char){//delete
  //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
  //}
  //  let slowDownCounter=0;
    let slower = 8;
    change();
  function change(){
    if(exit.current){
      return;
    }
    //slowDownCounter++;
  //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
  //    slower+=3; //slower of char
  //  }
  //  console.log(slower);
    if(i>changeTo){
      i-=speed;
      if(i<changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else{
    parent[prop] = i+um;
  }
requestAnimationFrame(change);
return;
}
});
}


async function textAppearing(text, position, name, answers){
  if(exit.current){
    return;
  }
  texting.current = true;
  stopTexting.current = false; //resetting stopTexting var
  if(name){
    setCharName(name);
  }
  if(position == "left"){
    textBoxRight.current.style.display = "none";
    textBoxLeft.current.style.display = "block";
      textBoxLeft.current.style.transform = "translate("+(-0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px) scale(0)";
      if(!answers){
        await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
      }else{
        await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
      }
      prevPosition.current = position;
  }else if(position == "right"){
    textBoxLeft.current.style.display = "none";
    textBoxRight.current.style.display = "block";
    textBoxRight.current.style.transform = "translate("+(0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px) scale(0)";
    if(!answers){
      await setTextParameters(textBoxRight, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }else{
      await setTextParameters(textBoxRight, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }
    prevPosition.current = position;
  }else if(position == "center"){
    textBoxRight.current.style.display = "none";
    textBoxLeft.current.style.display = "block";
    textBoxLeft.current.style.transform = "translate("+(-0.5)*document.body.clientWidth+"px, "+(-0.2)*document.body.clientHeight+"px) scale(0)";
    if(!answers){
      await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, 0, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }else{
      await setTextParameters(textBoxLeft, "current.style.transform", 0, 2.5, -20, 1, 1, 0.05, "current.style.opacity", 1, 0.05, position);
    }
    prevPosition.current = position;
  }
let i = 0;
let speed = 20; /* The speed/duration of the effect in milliseconds */
let txtHTML = "";
let open = "", close = "";
if(text.includes("<small><i>")){
  text = text.split("<small><i>")[1];
  text = text.split("</small></i>")[0];
  open = "<small><i>";
  close = "</small></i>";
}
if(text.includes("<i>")){
  text = text.split("<i>")[1];
  text = text.split("</i>")[0];
  open = "<i>";
  close = "</i>";
}
await typeWriter();
if(answers){
setTimeout(fff,200);
}
function fff(){
  answersAppearing(answers);
}

//
async function typeWriter() {
  if(exit.current){
    return;
  }
  return new Promise((resolve, reject) => {
  if(text.length>5){
    if(i===6){ //setting skipbutton
      skipButton.current = true;
    }
  }else{
    skipButton.current = true;
  }
  if (i < text.length) {
    txtHTML += text.charAt(i);
    if(text.charAt(i+1)){
      txtHTML += text.charAt(i+1);
    }
    if(position === "left" || position === "center"){
        setTextBoxLeftText("<p>"+open+txtHTML+close+"</p>");
    }else if(position === "right"){
        setTextBoxRightText("<p>"+open+txtHTML+close+"</p>");
    }
    i+=2;
    if(stopTexting.current == false){
      if(i>=text.length-1){
        texting.current = false;
        skipButton.current = false;
        resolve();
      }
     setTimeout(awaitTypeWriter, speed);
     async function awaitTypeWriter(){
       await typeWriter();
       resolve();
     }
  }else if(stopTexting.current == true){
    if(position === "left" || position === "center"){
    setTextBoxLeftText("<p>"+open+text+close+"</p>");
    }else if(position === "right"){
    setTextBoxRightText("<p>"+open+text+close+"</p>");
    }
      texting.current = false;
      skipButton.current = false;
      resolve();
      return;
    }
  }
});
}
}

async function textDisappearing(){
  if(exit.current){
    return;
  }
  if(prevPosition.current == "left"){
    await setTextParameters(textBoxLeft, "current.style.transform", -50, 2.5, -20, 1, 0, 0.05, "current.style.opacity", 0, 0.05, prevPosition.current);
    setTextBoxLeftText("");
    await waitingFunc(100);
  }else if(prevPosition.current == "right"){
    await setTextParameters(textBoxRight, "current.style.transform", 50, 2.5, -20, 1, 0, 0.05, "current.style.opacity", 1, 0.05, prevPosition.current);
    setTextBoxRightText("");
    await waitingFunc(100);
  }
  else if(prevPosition.current == "center"){
    await setTextParameters(textBoxLeft, "current.style.transform", -50, 2.5, -20, 1, 0, 0.05, "current.style.opacity", 0, 0.05, prevPosition.current);
    setTextBoxLeftText("");
    await waitingFunc(100);
  }
  return;
}
 function answersDisappearing(answer){
   if(exit.current){
     return;
   }
  return new Promise(async (resolve, reject) => {
  if(answersBox.current.style.display === "flex"){
    await changeSetting(eval("answerBox"+answer),"current.style.opacity", 0, "", 0.03);
    let arr =  [0,1,2,3];
    arr.splice(answer, 1);
    for(let key in arr){
      let v = Math.floor(Math.random() * ((arr.length-1) - 0 + 1) + 0);
      await changeSetting(eval("answerBox"+arr[v]),"current.style.opacity", 0, "", 0.03);
      arr.splice(v, 1);
    }
  answersBox.current.style.display = "none";
  setTimeout(f,200);
  function f(){
    resolve();
  }
}else{
  resolve();
}
});
}
async function answersAppearing(answers){
  if(exit.current){
    return;
  }
  answersBox.current.style.display = "flex";
  let ansNum;
  for(let key in answers){
    eval("answerBox"+parseInt(key)).current.style.display = "flex";
    eval("answerBox"+parseInt(key)).current.innerHTML = answers[key];
    ansNum = key;
  }
  for(ansNum+=1;ansNum<4;ansNum++){
    eval("answerBox"+parseInt(ansNum)).current.style.display = "none";
  }
  for(let key in answers){
    changeSetting(eval("answerBox"+parseInt(key)),"current.style.transform", 1, "scale", 0.03);
    await changeSetting(eval("answerBox"+parseInt(key)),"current.style.opacity", 1, "", 0.03);
  }
}

async function answerHandler(e){
  if(answering.current){
  answering.current=false;
  await answer();
  }
    function answer(){
      if(exit.current){
        return;
      }
          return new Promise(async (resolve, reject) => {
              answered.current = e.target.innerHTML;
              if(arrowBackVisible.current){
                clearTimeout(arrowBackVisible.current);
                backMenuDisappear();
              }
              await answersDisappearing(e.target.getAttribute('name'));
              await textDisappearing();
              wrap.current.style.zIndex = 10;
              resolve();
            });
          }
}

async function backMenuAppear(){
  if(exit.current){
    return;
  }
  if(!arrowBackVisible.current && backMenuCheck.current == false){
    backMenuCheck.current = true;
    arrowBack.current.style.display = "block";
    await changeSetting(arrowBack,"current.style.opacity", 1, "", 0.03);
    arrowBackVisible.current = true;
    arrowBackVisible.current = setTimeout(() => {
  backMenuDisappear();
}, 7000);
  }
}

async function backMenuDisappear(){
  if(exit.current){
    return;
  }
  if(arrowBackVisible.current && backMenuCheck.current == true){
  backMenuCheck.current = false;
  await changeSetting(arrowBack,"current.style.opacity", 0, "", 0.01);
  arrowBack.current.style.display = "none";
  arrowBackVisible.current = false;
}
}

async function achievementAppear(achievementUnlock){
  if(exit.current){
    return;
  }
  let text = 'Achievement unlocked!<br/>"' + achievementUnlock[1] +'"';
  achievementUnlock[2] = 1;
  achievement.current.style.display = "flex";
  let h = achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].clientHeight+4;
  achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].style.marginTop = (40-h)/2+"px";
  await changeSetting(achievement,"current.style.transform", 1, "scale", 0.03);
  achievement.current.querySelectorAll("p")[0].innerHTML = text;
  let w = achievement.current.querySelectorAll("p")[0].clientWidth;
  await width();
  achievement.current.querySelectorAll("p")[0].style.opacity = "1";
  achievement.current.querySelectorAll("p")[0].innerHTML = '';
  var txtHTML = "", i = 0;
  await changeSetting(achievement.current.getElementsByClassName("cup")[0],"style.transform", 90, "rotateY", 3);
  achievement.current.getElementsByClassName("cup")[0].querySelectorAll("h4")[0].innerHTML = achievementUnlock[0];
   changeSetting(achievement.current.getElementsByClassName("cup")[0],"style.transform", 0, "rotateY", 3);
  setTimeout(typeWriter, 50);
  setTimeout(achievementDisappear, 3000);


  async function width(){
    if(exit.current){
      return;
    }
    return new Promise(async (resolve, reject) => {
      setTimeout(fu,300);
        async function fu(){
          if(exit.current){
            return;
          }
  await changeSetting(achievement,"current.style.width", (w+60+20), "px", 4);
  resolve();
}
});
}

  async function typeWriter() {
    if(exit.current){
      return;
    }
    return new Promise((resolve, reject) => {
    if (i < text.length) {
      txtHTML += text.charAt(i);
      if(text.charAt(i+1)){
        txtHTML += text.charAt(i+1);
      }
      achievement.current.querySelectorAll("p")[0].innerHTML = txtHTML;
      i+=2;
        if(i>=text.length-1){
          resolve();
        }
       setTimeout(awaitTypeWriter, 20);
       async function awaitTypeWriter(){
         if(exit.current){
           return;
         }
         await typeWriter();
         resolve();
       }
    }
  });
}
}

async function achievementDisappear(){
  if(exit.current){
    return;
  }
  changeSetting(achievement.current.querySelectorAll("p")[0],'style.opacity', 0, "", 0.06);
  await changeSetting(achievement,"current.style.width", 50, "px", 4);
  await disap();
  achievement.current.style.display = "none";
  async function disap(){
    return new Promise(async (resolve, reject) => {
      setTimeout(fu,300);
        async function fu(){
          if(exit.current){
            return;
          }
          await changeSetting(achievement,"current.style.transform", 0, "scale", 0.03);
  resolve();
}
});
}
}
  return (
<div className='wrapTest' style={{overflow:"hidden"}}>
<div className='achievement' ref={achievement} style={{transform: "scale(0)", display:"none", width:"50px", zIndex:"11", position:"fixed"}}>
<p className='achievementText' style={{opacity:"0"}}></p>
<div className='cup' style={{transform: "rotateY(0deg)"}}>
  <h4 className='achievementEmoji'>🏆</h4>
  </div>
</div>
<div className='clickWrapVN' onClick={skipText} ref={wrap} id='wrap' style={{opacity:"1",zIndex:"10"}}></div>
<div className='clickWrapVN' ref={wrapMast} id='wrapMast' style={{opacity:wrapMastOpacity,zIndex:"5"}}></div>
<div className='backWrapVNTest' onClick={backMenuAppear} style={{opacity:"1",zIndex:"15"}}>
<div className="arrowBackWrap" onClick={goToMenu} ref={arrowBack} style={{opacity:"0", display:"none", transform:"scale(1)", backgroundColor: "rgba(0, 0, 0, 0.5)"}}><div className="arrowBack" >
    <div></div>
    </div>
</div>
</div>
<img src="" className='char' ref={charRefLeft} style={{left:"-100vw", opacity:"0%", bottom:"-20vh"}}/>
<img src="" className='char' ref={charRefRight} style={{right:"0vw", opacity:"0%", bottom:"-20vh"}}/>
<div className="textBoxCoverMastGame" ref={textBoxCover} style={{display:"block", zIndex:9, position:"fixed"}}>
<div className="textBox" ref={textBoxLeft} style={{left:"0vw", opacity:"0",  top:"0vh", width:"100%", transform:"translate(-50vw, -20vh)"}}><h1>{charName}</h1><div className="box-inner" id="textBoxLeft">{textBoxLeftText ? parse(textBoxLeftText) : parse(textBoxLeftText)}</div></div>
<div className="textBox" ref={textBoxRight} style={{right:"0vw", opacity:"0",  top:"0vh", width:"100%", transform:"translate(50vw, -20vh)"}}><h1>{charName}</h1><div className="box-inner" id="textBoxRight">{textBoxRightText ? parse(textBoxRightText) : parse(textBoxRightText)}</div></div>
<div className='answersVN' ref={answersBox} style={{display:"none"}}>
    <div className='answerVN' ref={answerBox0} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="0"></div>
    <div className='answerVN' ref={answerBox1} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="1"></div>
    <div className='answerVN' ref={answerBox2} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="2"></div>
    <div className='answerVN' ref={answerBox3} style={{opacity:"0", display:"none", transform: "scale(0)"}} onClick={answerHandler} name="3"></div>
</div>
</div>
<input type="range" ref={range} style={{display:"none", opacity:"0"}} onChange={sixthStageGoing ? sixthStageSpeedChecker : null} orient="vertical" id="speedRange" name="vol" min="1" step="0.5" max="27" defaultValue="0" />
<div className="parametrs" ref={parametrs} style={{display:"none", opacity:"0", transform:"scale(0)"}}>
<div className="stamina">
  <div className="stamina-progress stamina-progress-moved">
    <div className="stamina-progress-bar" ref={stamina} style={{width: "100%", background:"#04db19", transform:"translate(0px, 0px) scale(100%, 1)"}}>
    </div>
  <div className="stamina-progress_percent" >{textTranslation[language]["stamina"]}</div>
  </div>
</div>
</div>
<img src={background} className='backgroundMasturbationGame' ref={bgRef} style={{left:"0vw", filter: "blur(0px)", transform:"translate(0vw, 0vh)"}}/>
<img src={hand} className='backgroundMasturbationGame' ref={handRef} style={{left:"0vw", filter: "blur(0px)", transform:"translate(0vw, 0vh)", zIndex:"2"}}/>
</div>
  );
}

export default MasturbationGame;
